import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import { connect } from 'react-redux';

@connect((store) => {
    return { user: store.user }
})
export default class IncCapsuleChangeGroup extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return <div>

            <h4 className="mar-b25">Change the Groups</h4>
            <div className="mar-b25">You are about to set or change the groups that Trust Pilot syncs contacts with.</div>
            <div className="mar-b25">If you proceed, your Trust Pilot contacts  be automatically added to this group. </div>
            <div className="mar-b25">If you delete this group in the future, your Turst Pilot contacts will stop being synced.</div>
            <div className="mar-b25">You can change this group at any time.</div>

            <Button text="Select this Group" className="outline primary" onClick={this.props.changeTheGroup} />

        </div>
    }
};

